import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "červen a září"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 20 let zkušeností s pořádáním vodáckých zájezdů pro dorost i dospělé, dětských letních vodáckých táborů, ale především vodáckých a turistických kurzů pro střední školy v České, Slovenské a Polské republice. Vyškolení instruktoři vodáckého výcviku. "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "center" }, "Pedagogický doprovod zdarma.", -1)

import CommonPage from "@/components/CommonPage.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Kurzy',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonPage, { title: "VODÁCKÉ A TURISTICKÉ KURZY" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }))
}
}

})